import { h } from 'preact'
import { BulkAction } from '../index'
import { performBulkActionForTopics } from './utils'
import ButtonControl from '../../button-control'
import Icon from '../../assets'

export const closeTopic = () => ({
  Component: ({ performBulkAction } : { performBulkAction: (bulkAction: BulkAction) => void}) =>
    <ButtonControl
      title={<div><Icon icon='lock' width={16} height={16} />Close topic</div>}
      size='medium'
      newStyle
      class='qa-close-topic'
      onClick={() => performBulkAction({
        onClick: (topics: any) => performBulkActionForTopics(topics, 'close'),
        successMessage: 'Topic(s) closed'
      })}
    />
})
